import { createUseStyles } from 'react-jss'
import { voucherValidationErrorStyles } from '../../../modules/shared/voucher-common.styles'

export const useStyles = createUseStyles(voucherValidationErrorStyles)
